import React, { ReactNode } from "react";
import { LinhaTabela } from "shared/components/table/LinhaTabela";
import { RegistroTabela } from "shared/components/table/RegistroTabela";
import {
  formatarDataString,
  formatarHorarioParaHoraMinuto,
} from "shared/util/functions/formatacoesDeValores/FormatarValores";
import { ContatosRealizadosDTO } from "types/dto/GestaoCobrancaContatoDTO";
import { getMotivoInadimplenciaFormatado } from "constants/EnumTipoMotivoInadimplencia";
import { getResultadoContatoFormatado } from "constants/EnumTipoResultadoContato";
import { getCanalComunicacaoFormatado } from "constants/EnumTipoCanalComunicacao";

interface RenderRowsProps {
  registros: ContatosRealizadosDTO[];
}

export const RenderRowsContatosRealizados: React.FC<RenderRowsProps> = (props) => {
  const getDataHoraFormatada = (data: string, horario: string): string => {
    let dataHoraFormatada = formatarDataString(data).concat(
      ` - ${formatarHorarioParaHoraMinuto(horario)}`
    );
    return dataHoraFormatada;
  };

  const renderRegistros = (registros: ContatosRealizadosDTO[]): ReactNode => {
    return registros.map((contatoRealizado: ContatosRealizadosDTO, index: number) => {
      return (
        <LinhaTabela
          id={`id-registro-acordos-realizados-${index}`}
          key={`key-registro-acordos-realizados-${index}`}
        >
          <RegistroTabela
            id={`contato-realizado-data-${contatoRealizado.id}`}
            key={`contato-realizado-data-${contatoRealizado.id}`}
          >
            <span>
              {getDataHoraFormatada(contatoRealizado.dataContato, contatoRealizado.horarioContato)}
            </span>
          </RegistroTabela>

          <RegistroTabela
            id={`contato-realizado-anotacoes-${contatoRealizado.anotacoes}`}
            key={`contato-realizado-anotacoes-${contatoRealizado.anotacoes}`}
          >
            <span>{contatoRealizado.anotacoes}</span>
          </RegistroTabela>

          <RegistroTabela
            id={`contato-realizado-responsavel-${contatoRealizado.nomeUsuarioResponsavelPeloContato}`}
            key={`contato-realizado-responsavel-${contatoRealizado.nomeUsuarioResponsavelPeloContato}`}
          >
            <span>{contatoRealizado.nomeUsuarioResponsavelPeloContato}</span>
          </RegistroTabela>

          <RegistroTabela
            id={`contato-realizado-com-${contatoRealizado.contatoRealizadoCom}`}
            key={`contato-realizado-com-${contatoRealizado.contatoRealizadoCom}`}
          >
            <span>{contatoRealizado.contatoRealizadoCom}</span>
          </RegistroTabela>

          <RegistroTabela
            id={`contato-realizado-canal-comunicacao-${contatoRealizado.canalComunicacao}`}
            key={`contato-realizado-canal-comunicacao-${contatoRealizado.canalComunicacao}`}
          >
            <span>{getCanalComunicacaoFormatado(contatoRealizado.canalComunicacao)}</span>
          </RegistroTabela>

          <RegistroTabela
            id={`contato-realizado-resultado-contato-${contatoRealizado.resultadoContato}`}
            key={`contato-realizado-resultado-contato-${contatoRealizado.resultadoContato}`}
          >
            <span>{getResultadoContatoFormatado(contatoRealizado.resultadoContato)}</span>
          </RegistroTabela>

          <RegistroTabela
            id={`contato-realizado-motivo-inadimplência-${contatoRealizado.motivoInadimplencia}`}
            key={`contato-realizado-motivo-inadimplência-${contatoRealizado.motivoInadimplencia}`}
          >
            <span>{getMotivoInadimplenciaFormatado(contatoRealizado.motivoInadimplencia)}</span>
          </RegistroTabela>
        </LinhaTabela>
      );
    });
  };

  return <>{props.registros.length > 0 && renderRegistros(props.registros)}</>;
};

export default RenderRowsContatosRealizados;
